import css from './ImageHelper.module.scss';
import classNames from 'classnames';
import { ImageHelperProps } from './ImageHelper.types';

export const ImageHelper = (({
    imageProps,
    fullyQualified,
    className,
}: ImageHelperProps) => {
    const formatUrl: () => string = () => {
        let url;

        if (!imageProps.src) {
            url = '';
        }
        else if (fullyQualified) {
            url = imageProps.src;
        }
        else {
            let pathName = imageProps.src;
            /*
             * for some unknown reason webpack returns an extra "." anywhere but locally
             * remove the "." so that the path can be domain relative
             */
            if (pathName[0] === '.') {
                pathName = pathName.substring(1);
            }

            if (!['http', 'file://', 'data:', process.env.PUBLIC_URL].some((prefix) => pathName.startsWith(prefix))) {
                pathName = process.env.PUBLIC_URL + pathName;
            }

            url = pathName;
        }

        return url;
    };

    return (
        <img
            {...imageProps}
            src={formatUrl()}
            alt={imageProps.alt || ''}
            className={classNames(css.image, css.contain, className)}
        />
    );
});